// extracted by mini-css-extract-plugin
module.exports = {"buttons":"externalCourses_buttons__3tbYL","dropdownManage":"externalCourses_dropdownManage__36SlI","search":"externalCourses_search__16lhp"};